import { getUrl, Request } from '../../request';

export const getSlider = (city_id, category_id, mobile, location = 'home_page', type) => {
  const query = {
    city_id,
    category_id,
    location,
    type
  };
  if (mobile) {
    query.mobile = 1;
  } else {
    query.desktop = 1;
  }
  return Request.get(getUrl('/api/v1/content/slider/'), query);
};

export const getLayoutSection = (city_id, category_id, type = 'home_page', mobile) => {
  const query = {
    city_id,
    category_id,
    type
  };
  if (mobile) {
    query.mobile = 1;
  } else {
    query.desktop = 1;
  }
  return Request.get(getUrl('/api/v1/content/layout-section/'), query);
};

export const getLayoutHeader = (city_id, type = 'header') => {
  const query = {
    city_id,
    type
  };

  return Request.get(getUrl('/api/v1/content/layout-header/'), query);
};

export const getFaqs = () => Request.get(getUrl('/api/v1/content/faq'));
